module.exports = __webpack_public_path__ + "img/add1.fdb3ae96.svg";